import { useRouter, useStore } from '@nuxtjs/composition-api'
import { catchError, empty, filter, from, tap, throwError } from 'rxjs'
import { checkAxiosData, getAxiosErr } from 'fe-common'
import { handleMessages } from '../modules/client/utilities'

export default function useLogout$() {
  const store = useStore()
  const router = useRouter()

  function logout$(afterPath = '/') {
    const logoutAfter = () => {
      store.commit('authModule/TOKEN', null)
      store.commit('authModule/TOKEN_EXP', null)

      const redirectAfter = () => {
        setTimeout(() => store.commit('authModule/USER', null), 0)

        if (
          window.opener &&
          window.opener.location.hostname === window.location.hostname
        ) {
          window.opener.location.reload()
        }
      }

      router.push(afterPath, redirectAfter, redirectAfter)
    }
    return from(store.dispatch('authModule/logout')).pipe(
      filter(
        data =>
          !data ||
          checkAxiosData(data, {
            handleMessages: handleMessages({
              store
            })
          })
      ),
      tap(() => logoutAfter()),
      catchError(err => {
        const { statusCode } = getAxiosErr(err)
        if (statusCode === 401) {
          logoutAfter()
          return empty()
        }
        return throwError(err)
      })
    )
  }

  return {
    logout$
  }
}
